import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, Modal, App as AntdApp } from 'antd';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import './style.css';

const { Title } = Typography;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [modal, contextHolder] = Modal.useModal();

  const onFinish = async (values: any) => {
    setLoading(true);
    const { email, password } = values;
    const { error, data } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      let msg = error.message;
      if (
        error.code === 'invalid_login_credentials' ||
        error.code === 'invalid_credentials' ||
        error.message === 'Invalid login credentials' ||
        error.status === 400
      ) {
        msg = '邮箱或密码错误，请重新输入';
      }
      setTimeout(() => {
        modal.error({
          title: '登录失败',
          content: msg,
          centered: true,
          okButtonProps: { style: { background: '#ffb86b', color: '#4b2e13', fontWeight: 700 } },
          maskClosable: true,
        });
      }, 100);
      return;
    }
    // 校验是否为管理员
    const { data: adminData } = await supabase
      .from('admins')
      .select('id')
      .eq('email', email)
      .single();
    if (!adminData) {
      let msg = '您不是管理员，无权登录';
      if (adminData === null) {
        msg = '邮箱或密码错误，请重新输入';
      }
      setTimeout(() => {
        modal.error({
          title: '无权登录',
          content: msg,
          centered: true,
          okButtonProps: { style: { background: '#ffb86b', color: '#4b2e13', fontWeight: 700 } },
          maskClosable: true,
        });
      }, 100);
      await supabase.auth.signOut();
      return;
    }
    navigate('/');
  };

  return (
    <AntdApp>
      {contextHolder}
      <div className="login-bg">
        <Card className="login-card">
          <div className="login-logo">
            <img src="/icon.png" alt="logo" />
            <span className="login-logo-text">UCDN 管理员登录</span>
          </div>
          <Form layout="vertical" onFinish={onFinish} className="login-form">
            <Form.Item name="email" label="邮箱" rules={[{ required: true, message: '请输入邮箱' }]}>
              <Input size="large" placeholder="请输入管理员邮箱" autoComplete="username" />
            </Form.Item>
            <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
              <Input.Password size="large" placeholder="请输入密码" autoComplete="current-password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" block loading={loading} style={{ borderRadius: 8, fontWeight: 600 }}>
                登录
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </AntdApp>
  );
};

export default LoginPage;
